import { render, staticRenderFns } from "./ActivitySidebarHeader.vue?vue&type=template&id=343e9c8e&"
import script from "./ActivitySidebarHeader.vue?vue&type=script&lang=js&"
export * from "./ActivitySidebarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343e9c8e')) {
      api.createRecord('343e9c8e', component.options)
    } else {
      api.reload('343e9c8e', component.options)
    }
    module.hot.accept("./ActivitySidebarHeader.vue?vue&type=template&id=343e9c8e&", function () {
      api.rerender('343e9c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivitySidebarHeader.vue"
export default component.exports